import { useAuth } from '../../auth/AuthContext';

function initialLetter(name) {
  if (!name || typeof name !== 'string') {
    return '?';
  }
  const t = name.trim();
  if (!t) {
    return '?';
  }
  return t[0].toUpperCase();
}

function SidebarProfileSection({ onCloseDrawer }) {
  const { user, authenticated, authChecked, openAuth } = useAuth();

  const displayName = authenticated
    ? user?.displayName || user?.username || 'Player'
    : authChecked
      ? 'Guest'
      : '';
  const badgeLetter = !authChecked ? '…' : authenticated ? initialLetter(displayName) : 'G';
  const subtitle = authenticated
    ? user?.email || 'Signed in'
    : authChecked
      ? 'Sign in to track progress'
      : 'Loading…';

  return (
    <>
      <div className="sidebar-brand-row">
        <div className="sidebar-brand">
          <button
            type="button"
            className={`profile-badge${authenticated ? '' : ' profile-badge--guest'}${
              !authChecked ? ' profile-badge--pending' : ''
            }`}
            aria-label={
              !authChecked
                ? 'Loading account'
                : authenticated
                  ? `Signed in as ${displayName}`
                  : 'Sign in'
            }
            disabled={!authChecked}
            onClick={() => {
              if (authChecked && !authenticated) {
                openAuth('signin');
              }
            }}
          >
            {badgeLetter}
          </button>
          <div className="brand-copy">
            <strong
              className={`brand-copy__name${!authChecked ? ' brand-copy__name--pending' : ''}`}
            >
              {authChecked ? displayName : '\u00a0'}
            </strong>
            <span className="brand-copy__meta" title={authenticated ? user?.email : undefined}>
              {subtitle}
            </span>
          </div>
        </div>
        <button
          type="button"
          className="sidebar-close-btn"
          aria-label="Close menu"
          onClick={onCloseDrawer}
        >
          ×
        </button>
      </div>
    </>
  );
}

export default SidebarProfileSection;
